import { apiSlice } from './apiSlice'

export interface KnowledgeLibraryItem {
  id?: string
  title: string
  description?: string
  category: string
  tags: string[]
  file_name: string
  file_size: number
  mime_type: string
  storage_path: string
  uploaded_by: string
  created_at?: string
  updated_at?: string
}

export const knowledgeLibraryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listKnowledgeLibrary: builder.query<KnowledgeLibraryItem[], void>({
      query: () => '/knowledge-library/list',
      providesTags: ['KnowledgeItem'],
    }),
    createKnowledgeLibraryItem: builder.mutation<
      KnowledgeLibraryItem,
      FormData
    >({
      query: (formData) => ({
        url: '/knowledge-library/create',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['KnowledgeItem'],
    }),
    deleteKnowledgeLibraryItem: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/knowledge-library/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['KnowledgeItem'],
    }),
    downloadKnowledgeLibraryItem: builder.query<Blob, string>({
      query: (id) => ({
        url: `/knowledge-library/${id}/download`,
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
})

export const {
  useListKnowledgeLibraryQuery,
  useCreateKnowledgeLibraryItemMutation,
  useDeleteKnowledgeLibraryItemMutation,
  useLazyDownloadKnowledgeLibraryItemQuery,
} = knowledgeLibraryApi
